import { array, required, obj, optional } from 'AppReact/schema';
import { option } from './inspectionTemplate';
import { event } from './event'

export const extendedItem = {
  id: required('integer'),
  name: required('string'),
  area: required('string'),
  num: required('integer'),
  input_type: required('string'),
  area_num: required('integer'),
  is_duplicable: required('boolean'),
  area_is_duplicable: required('boolean'),
  status: required('string'),
  options: array(obj(option)),
  events: array(obj(event)),
  order_id: optional('integer'),
  order_description: optional('string'),
  order_status: optional('string'),
}